<template>
    <div class="whatsapp_container">
        <!-- <a href="https://api.whatsapp.com/send?phone=5511975998619&text=Olá, gostaria de mais informações sobre o templo EDEM!" target="_blank" rel="noopener noreferrer"> -->
        <a href="https://api.whatsapp.com/send?phone=5511975998619&text=Olá, gostaria de mais informações sobre o templo EDEM!" target="_blank" rel="noopener noreferrer">   
            <img src="@/assets/whatsapp_icon.png" alt="WhatsApp Icon" />
        </a>
    </div>
</template>
<script>
export default {
    name: 'WhatsappIconPage'
};
</script>
<style scoped>
.whatsapp_container {
    position: fixed;
    bottom: 60px;
    right: 20px;
    z-index: 1000;
}
.whatsapp_container img {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease;
}
</style>